import { gql } from 'graphql-request'

export const EDIT_PEN_NAME = gql`
  mutation UpdatePenName($updatePenNameInput: UpdatePenNameInput!) {
    updatePenName(updatePenNameInput: $updatePenNameInput) {
      id
      firstPenName
      secondPenName
      facebookLink
      twitterLink
    }
  }
`
